import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { CustomerPortalService }           from './customer-portal.service';
import { CustomerPortalSettingsComponent } from './customer-portal.settings.component';
import { CustomerPortalStates }            from './customer-portal.states';
import { SharedModule }                    from '../shared/shared.module';

@NgModule({
  declarations: [
    CustomerPortalSettingsComponent
  ],
  entryComponents: [
    CustomerPortalSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: CustomerPortalStates })
  ],
  providers: [
    CustomerPortalService
  ]
})
export class CustomerPortalModule {}
